import { livePaths } from './paths';

// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog. */
export const serviceScopes = [
  // Penguin/LMS live services carry Internal.HLSLowLatency on the backend;
  // External.SwiftCoder.LMS is kept as a legacy alias for the same console.
  { scope: 'Internal.HLSLowLatency', category: 'streaming', route: livePaths.service },
  { scope: 'External.SwiftCoder.LMS', category: 'streaming', route: livePaths.service },
] as const;
